/**
 * One saved snapshot, rows included. The view renders from this stored
 * payload alone — reopening a snapshot never re-queries source data
 * (CR-SEQ-2026-025 §1.3.6).
 */
import { useQuery } from "@tanstack/react-query";

import { getReportSnapshot, ReportSnapshot } from "@services/reportEngine";

export const useReportSnapshot = (id?: string) => {
  return useQuery<ReportSnapshot>(
    ["reportSnapshots", "detail", id],
    () => getReportSnapshot(id!),
    {
      enabled: Boolean(id),
      refetchOnWindowFocus: false,
    },
  );
};
